import React, { useEffect, useState } from 'react';
import './style.scss';
import Pepe from './pepe';

const Pepes = () => {
  const [count, setCount] = useState(['']);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => prev.concat(''));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className='general-pepe-wrapper'>
      <div className='fuck-wrapper'>🖕</div>
      {count.map((_, index) => (
        <Pepe key={index} />
      ))}
    </div>
  );
};

export default Pepes;
